(function () {
  'use strict';

  /* @ngdoc object
   * @name sepa
   * @description
   *
   */
  angular
    .module('sepa', [
      'ui.router'
    ]);
}());
